import React from 'react'
import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'

const COFCancellationPolicyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '0.5rem',
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
  [theme.breakpoints.down('sm')]: {
    margin: '0 1rem',
  },
}))

export const COFCancellationPolicy = () => {
  return (
    <COFCancellationPolicyContainer>
      <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }} color="white">
        Cancellation Policy
      </Typography>

      <ul>
        <li>
          Cuban Overflight Permit (COF) requests are non-refundable once the
          purchase has been made.
        </li>
        <li>
          All COF requests that are cancelled are subject to a $170.00 USD
          cancellation fee. The remaining balance will be held as credit for a
          period of 3 months from the original submission date. After this
          period, any unused credit will be forfeited and is non-refundable.
        </li>
        <li>
          From the moment we receive the payment confirmation, up to 1
          additional modification to tail number, dates, times, airports and
          routes can be made free of charge. Starting with the second
          modification to an already submitted COF, a charge fee of $50.00 USD
          per change will be charged for every subsequent change to the COF.
        </li>
        <li>
          CST Members who fail to validate their CST Member email during this
          submission process will be charged full rate and no partial refunds
          can be given.
        </li>
        <li>
          Services cannot be combined or bundled under any circumstances. This
          policy applies exclusively to COF online requests. No credits,
          cancellations, or modifications may be transferred or applied between
          different services.
        </li>
      </ul>
    </COFCancellationPolicyContainer>
  )
}
